<template>
    <div class="midblock relative width100 padding15" style="display: flex; width:900px; max-width:100%;">
        <div class=" flex-pax" >
          <div id="adultPaxContainer">
            <div class="paxCounter">
              <b>Volwassenen  <small> (18+)&nbsp;</small></b>
              <button v-on:click="$emit('changeCompany'); (cabin.volwassenen = decAdult(cabin.volwassenen)); removeComponent('volwassenen')" id="testvolwassenenmin" class="btn-pax">
                <font-awesome-icon icon="minus" />
              </button>

              <span>{{ cabin.volwassenen }}</span>

              <button v-on:click="$emit('changeCompany'); (cabin.volwassenen = incAdult(cabin.volwassenen));" id="testvolwassenenplus" class="btn-pax">
                <font-awesome-icon icon="plus" />
              </button>

              <small><i v-if="minAdult >= 2"> Minimaal 2</i></small>
              <br />
            </div>

            <div v-if="cabin.volwassenen && parseInt(cruise.rederij_id) === 14">
              <div v-for="item in parseInt(cabin.volwassenen)">
                <CabinConfigBirthday initialValue="1990-01-01" :initialMinDate="moment(new Date()).add(-118, 'y').format('YYYY-MM-DD')" :initialMaxDate="moment(new Date()).add(item === 1 ? -21 : -18, 'y').format('YYYY-MM-DD')" initialLabel="Volw" initialType="volwassenen" :initialIndex="item-1" @birthdate-updated="updateBirthdate"/>
              </div>
            </div>


          </div>

          <div id="youthPaxContainer" v-if="!rivierOnly && !cruise.adultsOnly">
            <div class="paxCounter">
              <b>Jeugd
                <small> (13 t/m 17)&nbsp;</small>
              </b>

              <button v-on:click="$emit('changeCompany'); (cabin.jeugd = decOne(cabin.jeugd)); removeComponent('jeugd');" id="testjeugdmin" class="btn-pax">
                <font-awesome-icon icon="minus" />
              </button>

              <span>{{ cabin.jeugd }}</span>

              <button v-on:click="$emit('changeCompany'); (cabin.jeugd = incOne(cabin.jeugd));" id="testjeugdplus" class="btn-pax">
                <font-awesome-icon icon="plus" />
              </button>
            </div>

            <div v-if="cabin.jeugd">
              <div v-for="item in parseInt(cabin.jeugd)">
                <CabinConfigBirthday :initialValue="moment(new Date()).add(-17, 'y').format('YYYY-MM-DD')" :initialMinDate="moment(new Date()).add(-17, 'y').format('YYYY-MM-DD')" :initialMaxDate="moment(new Date()).add(-13, 'y').format('YYYY-MM-DD')" initialLabel="Jeugd" initialType="jeugd" :initialIndex="item-1" @birthdate-updated="updateBirthdate"/>
              </div>
            </div>

          </div>

          <div id="childPaxContainer" v-if="!cruise.adultsOnly">
            <div class="paxCounter">
              <b>Kind
                <small> (2 t/m 12)</small>
              </b>

              <button v-on:click="$emit('changeCompany'); (cabin.kinderen = decOne(cabin.kinderen)); removeComponent('kinderen');" id="testkinderenmin" class="btn-pax">
                <font-awesome-icon icon="minus" />
              </button>

              <span>{{ cabin.kinderen }}</span>

              <button v-on:click="$emit('changeCompany'); (cabin.kinderen = incOne(cabin.kinderen));" id="testkinderenplus" class="btn-pax">
                <font-awesome-icon icon="plus" />
              </button>

            </div>

            <div v-if="cabin.kinderen">
              <div v-for="item in parseInt(cabin.kinderen)">
                <CabinConfigBirthday :initialValue="moment(new Date()).add(-12, 'y').format('YYYY-MM-DD')" :initialMinDate="moment(new Date()).add(-12, 'y').format('YYYY-MM-DD')" :initialMaxDate="moment(new Date()).add(-2, 'y').format('YYYY-MM-DD')" initialLabel="Kind" initialType="kinderen" :initialIndex="item-1" @birthdate-updated="updateBirthdate"/>
              </div>
            </div>
          </div>

          <div id="babyPaxContainer" v-if="!cruise.adultsOnly && !(cruise.rederij_id == 38)">
            <div class="paxCounter">
              <b>Baby
                <small> (0 t/m 1)</small>
              </b>

              <button v-on:click="$emit('changeCompany'); (cabin.baby = decOne(cabin.baby)); removeComponent('baby');" id="testbabymin" class="btn-pax">
                <font-awesome-icon icon="minus" />
              </button>

              <span>{{ cabin.baby }}</span>

              <button v-on:click="$emit('changeCompany'); (cabin.baby = incOne(cabin.baby));" id="testbabyplus" class="btn-pax">
                <font-awesome-icon icon="plus" />
              </button>

            </div>

            <div v-if="cabin.baby">
              <div v-for="item in parseInt(cabin.baby)">
                <CabinConfigBirthday :initialValue="moment(new Date()).add(-1, 'y').format('YYYY-MM-DD')" :initialMinDate="moment(new Date()).add(-1, 'y').format('YYYY-MM-DD')" :initialMaxDate="moment(new Date()).add(0, 'y').format('YYYY-MM-DD')" initialLabel="Baby" initialType="baby" :initialIndex="item-1" @birthdate-updated="updateBirthdate"/>
              </div>
            </div>
          </div>

            <br />
            <small v-if="totalPax >= maxPax">
              <i>Minimaal {{ minAdult }} volwassenen, maximaal {{ maxPax }} reizigers.</i>
            </small>

        </div>
      <button type="button" style="height:38px;" id="teststap2wijzigen" class="btn btn-success btn-addon font14 bold floatright" v-on:click="setPeopleAndStep(2)" v-bind:class="{
        'disabled' : invalidBirthdate()
      }">
        Ga door
        <font-awesome-icon icon="angle-right" />
      </button>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import CabinConfigBirthday from "./CabinConfigBirthday.vue"
import {
    faChild,
    faLaugh,
    faMinusCircle,
    faPlusCircle,
    faUser,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

library.add(faPlusCircle, faMinusCircle, faChild, faUser, faLaugh)

export default {
    name: 'CabinConfig',
    components: {
      CabinConfigBirthday,
    },
    data: function() {
        return {
          maxPax: 5,
          birthdates: {
            volwassenen: [],
            jeugd: [],
            kinderen: [],
            baby: [],
          }
        }
    },
    props: {
        cabin: Object,
        cruise: Object,
        index: Number,
        minAdult: Number,
        setActiveStep: Function,
      setPeopleAndStep: Function,
    },
    computed: {
        // Check if riviercruises
        rivierOnly: function() {
            var host = window.location.hostname
            //var host = 'rivier' dev
            return host.includes("rivier");
        },
    },
    methods: {
      updateBirthdate({ index, birthdate, type }) {
        if (!this.cabin.birthdates[type]) {
          this.$set(this.cabin.birthdates, type, []);
        }

        this.$set(this.cabin.birthdates[type], index, birthdate);

        this.$emit('changeBirthdateCompany')
      },
        removeComponent(type) {
          if(this.cabin[type] != this.cabin.birthdates[type].length){
            this.cabin.birthdates[type].pop();
          }
        },
        maxPax2: function() {
            return this.rivierOnly ? 2 : 5 ;
        },
        incAdult: function(value) {
            if (this.totalPax() < this.maxPax) {
                return parseInt(value) + 1
            }
            return value
        },
        decAdult: function(value) {
            if (value > this.minAdult) {
                return parseInt(value) - 1
            }
            return value
        },
        incOne: function(value) {
            if (
                this.totalPax() < this.maxPax &&
                this.cabin.volwassenen >= this.minAdult
            ) {
                return parseInt(value) + 1
            }
            return value
        },
        decOne: function(value) {
            if (value > 0) {
                return parseInt(value) - 1
            }
            return value
        },
        totalPax: function() {
            return (
                parseInt(this.cabin.volwassenen) +
                parseInt(this.cabin.jeugd) +
                parseInt(this.cabin.kinderen) +
                parseInt(this.cabin.baby)
            )
        },
      invalidBirthdate: function() {

        if(parseInt(this.cruise.rederij_id) !== 14) {
          return false;
        }

        var cantContinue = false;
        for (const [key, value] of Object.entries(this.cabin.birthdates)) {

          if(cantContinue) {
            return true;
          }
          var birthdates = value.toString().split(',');

          var filtered = birthdates.filter(function (el) {
            return el != "";
          });

          var minAge = 18;
          if(key === 'volwassenen') {
             minAge = 21;
          } else if(key === 'jeugd') {
            minAge = 12;
          } else if(key === 'kinderen') {
            minAge = 2;
          } else if(key === 'baby') {
            minAge = 0;
          }

          filtered.forEach(function(birthdate) {

            if(moment(birthdate).add(minAge, 'y').format('YYYY') > moment().format('YYYY')) {

              cantContinue = true
              return false;
            }

            if(minAge === 21) {
              minAge = 18
            }
          })

        }

        return cantContinue;
      }
    },
}

</script>
<style>
.btn-pax {
  border:0;
  background: #fff;
  color: #2178b3;
  font-size:12px;
  font-weight: initial;
  cursor: pointer;
}
.btn-pax:hover {
  background: #fff;
  color: #2178b3;
}
.flex-pax {

  margin-top: 10px;
 display: flex;justify-content: space-between; width:100%; }
.flex-pax > div {
  width:25%;
  font-weight: bold;
  text-align: center;
  border-left: 1px solid #d9d5d5;
}
.flex-pax div:first-child {
  border-left:1px solid transparent;

}
.flex-pax small {
  font-weight: initial;
  padding-left:5px;
}
.flex-pax span {
  font-size:16px;
}
.paxCounter + div {
  margin-top:15px;
}
@media screen and (max-width: 1200px) {
  .flex-pax {
    flex-wrap:wrap;
    flex-flow: column;
  }
  .flex-pax > div {
    width:100%;
    min-height:30px;
    border-left: 0;
    text-align: left;
    display: flex;
    line-height: 30px !important;
    margin-bottom: 5px;
    flex-flow:column;
  }
  .flex-pax div .btn-pax {
    margin-left:10px;
  }
  .flex-pax span ~ .btn-pax {
    margin-left: 0px;
  }
  .flex-pax b {
    width:120px;
    max-width:50%;
  }
  .paxCounter + div {
    margin-top:0px;
  }
}

.disabled {
  pointer-events: none;
  filter: grayscale(100) opacity(0.50);
}
</style>
